import React from "react";
import { Divider, Menu, Typography } from "antd";
import { MenuInfo } from "rc-menu/lib/interface";

import { useBenchmarkContext } from "./hook";
import { TitleCase } from "@/utils/string";

export default () => {
  const { selectedKey, setSelectedKey, investmentStyles } = useBenchmarkContext();

  return (
    <div>
      <Typography.Text strong underline>
        Investment Styles:
      </Typography.Text>
      <Divider />
      <Menu mode={"inline"} selectedKeys={selectedKey} onClick={onMenuClick}>
        {investmentStyles
          .sort((a, b) => a.localeCompare(b))
          .map(e => (
            <Menu.Item key={e}>{TitleCase(e)}</Menu.Item>
          ))}
      </Menu>
    </div>
  );

  function onMenuClick({ key }: MenuInfo) {
    const targetKey = key as string;
    const index = selectedKey.indexOf(targetKey);
    if (index >= 0) {
      // Remove from menu
      if (selectedKey.length > 1) {
        selectedKey.splice(index, 1);
        setSelectedKey([...selectedKey]);
      }
    } else {
      if (selectedKey.length < 4) {
        // Add to menu
        setSelectedKey([...selectedKey, targetKey]);
      } else {
        setSelectedKey([...selectedKey.slice(1,4), targetKey]);
      }

    }
  }
};
